module.exports = function getResource(label) {
    const resources = {
        accountClosed: 'Account Successfully Closed',
        loggedOut: 'You are now logged out.',
        message: 'If you have questions regarding closing your account, please call our Customer Service team at 1-877-SEPHORA (1-877-737-4672) or Chat with our representatives.'
    };
    return resources[label];
};

